import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/shopware': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M403.5 455.4c-36.1 26.8-101.9 48.6-146.8 48.6-0.2 0-0.5 0-0.7 0-137.2 0-248-111-248-248 0-137.2 111-248 248-248h0.2c52.4 0 126.5 28.4 165.5 63.5 0.6 0.6 1.2 1.8 1.2 2.6 0 2-1.6 3.6-3.6 3.6-0.1 0-0.3 0-0.5 0-15.2-2-40-3.7-55.4-3.7-0.4 0-0.9 0-1.3 0-129.4 0-222.4 53.5-222.4 155.3 0 109 92.1 145.9 176.8 178.7 33.6 13 65.4 25.4 87 41.6 0.8 0.6 1.4 1.9 1.4 2.9 0 1-0.6 2.3-1.4 2.9zM503 233.1c0.6 6.3 1 16.5 1 22.8 0 25.9-7.6 66.4-17 90.5-0.5 1.2-2 2.2-3.3 2.2-0.5 0-1.3-0.2-1.7-0.4-29.5-16.4-61.6-28.3-92.7-39.9-60.3-22.5-112.3-41.9-112.3-84.5 0-1.5-3.9-53.6 80.3-53.6 50.9 0 92.7 17.5 144.5 60.5 0.6 0.5 1.2 1.6 1.3 2.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/shopware.js
// module id = 1012
// module chunks = 0